<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" size="lg-fix-h" :ariaLabel="$t('app.detail_errors_header') + ' ' + clientError">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('app.detail_errors_header')}} {{clientError}}</h2>
          <base-tooltip-icon size="sm" :content="extensionTooltipMessage" class="ml-2"/>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="vld-parent" style="min-height: 350px">
      <loading 
        :opacity="darkMode ? 0 : 0.5" 
        :background-color="darkMode ? 'var(--darkblue-DEFAULT)' : 'white'" 
        color="var(--primary-DEFAULT)" 
        :active="!isLoadedData" 
        :is-full-page="false" 
        :z-index="100000">
        </loading>
      <errors-table 
        ref="errorsTableRef"
        class="m-2"
        :currentPage="currentPage"
        :totalPage="totalPage"
        :tableData="dataTable" 
        :total="totalData"
        @changeCurrentPage="changeCurrentPage"
        @getData="getData"> 
      </errors-table>
      </div>
    </template>
    <template slot="footer">
      <div class="w-full items-end justify-end flex space-x-2 px-4 bg-white py-2 mt-auto dark:bg-darkblue-900">
        <base-button-responsive mode="secondary-phantom-blue" :text="$t('app.export_excel')" icon='excelxls' @click='exportExcel'
          :loading='!isLoadedData || !isLoadedExcel' 
          :disabled="!isLoadedData || !isLoadedExcel" />
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.close')" />
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from '../base/BaseDialogButton.vue'
import ErrorsTable from '@/components/errors/ErrorsTable.vue'
import Loading from 'vue-loading-overlay'
import { getErrors } from '@/services/errors/getErrors'
import { getErrorsExcel } from '@/services/errors/getErrorsExcel'
import moment from 'moment'

export default
{
  name: 'detail-errors-dialog',
  components: {
    BaseDialogButton,
    ErrorsTable,
    Loading,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      if (value) {
        this.getData()
      } else {
        this.cleanData()
      }
    },
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      isLoadedData: false,
      isLoadedExcel: true,
      dataTable: [],
      totalData: 0,
      extensionTooltipMessage: 'Errores de todas las empresas por sedes vinculadas a éstas en la vigilancia de notificaciones en las últimas 24 horas',
      currentPage: 1,
      totalPage: 0,
    }
  },
  mounted: async function () {
  },
  computed: {
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isSA: function () {
      return (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador')
    },
    selectedClientDashboard () {
      return this.$store.getters['dashboard/getSelectedClient']
    },
    selectedClientNameDashboard () {
      return this.$store.getters['dashboard/getSelectedClientName']
    },
    clientError () {
      if (this.isSelectedClientDashboard) {
        return ' del cliente ' + this.selectedClientNameDashboard
      }
      return ''
    },
    isSelectedClientDashboard () {
      return this.selectedClientDashboard !== undefined && this.selectedClientDashboard !== null && this.selectedClientDashboard !== 0 && this.selectedClientDashboard !== -1
    },
  },
  methods: {
    exportExcel: async function () {
      this.isLoadedExcel = false
      try {
        const data = this.$refs.errorsTableRef.getActualSortFilters()
        const response = await getErrorsExcel({ idCliente: this.getParamIdClient() }, data) 
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'errores.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.isLoadedExcel = true
      }
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    getParamIdClient () {
      const idClient = this.$store.getters['dashboard/getSelectedClient']
      if (this.isSA && idClient !== 0 && idClient !== null) return this.$store.getters['dashboard/getSelectedClient']
      return null
    },
    cleanData () {
      this.dataTable = []
      this.totalData = 0
      this.currentPage = 1
      this.totalPage = 0
    },
    formatDate: function (strDate) {
      return moment(strDate).format('DD-MM-yyyy HH:mm')
    },
    getData: async function (data) {
      this.isLoadedData = false
      this.dataTable = []
      try {
        // const paramIdClient = this.getParamIdClient()
        const response = await getErrors({ page: this.currentPage, idCliente: this.getParamIdClient() }, data)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          setTimeout(() => {
            const finalData = []
            let cont = 1
            response.ListaEmpresasError.forEach(x => {
              const empresaValue = this.isSA && !this.isSelectedClientDashboard ? x.Cif.NombreCliente + ' - ' + x.Cif.Cif + ' - ' + x.Cif.Nombre : x.Cif.Cif + ' - ' + x.Cif.Nombre
              finalData.push({
                idCola: cont,
                idCIFEmpresa: x.Cif.idCifEmpresa,
                empresa: empresaValue,
                idPGN: x.Sede.idPgn,
                sede: x.Sede.Nombre,
                error: x.Error,
                fecha: this.formatDate(x.Fecha),
                hasChildren: true,
              })
              cont++
            })
            this.dataTable = finalData
            this.totalData = response.meta?.total
            this.currentPage = response.meta?.currentPage
            this.totalPage = response.meta?.total
          }, 10)
        }
      } catch (error) {
        this.doFeedback('Tiempo de espera superado / Error general')
      } finally {
        this.isLoadedData = true
      }
    },
    changeCurrentPage (numPage) {
      this.currentPage = numPage
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
